import React from 'react';
import { Paper } from '@lifeomic/chroma-react/components/Paper';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';

export const useStyles = makeStyles((theme: Theme) => ({
  mobileRoot: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
}));

export type RootClasses = GetClasses<typeof useStyles>;

export interface RootOwnProps {
  isMobile: boolean;
  children: any;
}

export type RootProps = RootOwnProps;

const Root = (props: RootProps) => {
  const classes = useStyles(props);

  if (props.isMobile) {
    return <div className={classes.mobileRoot}>{props.children}</div>;
  } else {
    return <Paper className={classes.paper}>{props.children}</Paper>;
  }
};

export default React.memo(Root);
